export const AUTH = {
    LOGIN: "LOGIN",
    USER_FETCH : "USER_FETCH"
}